import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'

import {
  DEFAULT_LOCALE,
  persistLocale,
  readStoredLocale,
  resolveLocale,
  syncDocumentLanguage,
  translate,
} from './locale'
import { en } from './translations/en'
import { fr } from './translations/fr'

const DICTIONARIES = {
  en,
  fr,
}

const LocaleContext = createContext(null)

export function LocaleProvider({ children }) {
  const [locale, setResolvedLocale] = useState(() => readStoredLocale())

  useEffect(() => {
    syncDocumentLanguage(locale)
    persistLocale(locale)
  }, [locale])

  const setLocale = useCallback((nextLocale) => {
    setResolvedLocale(resolveLocale(nextLocale))
  }, [])

  const t = useCallback(
    (key, params) => translate(DICTIONARIES[locale], DICTIONARIES[DEFAULT_LOCALE], key, params),
    [locale],
  )

  const value = useMemo(() => ({
    locale,
    setLocale,
    t,
  }), [locale, setLocale, t])

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  )
}

export function useLocale() {
  const context = useContext(LocaleContext)

  if (!context) {
    throw new Error('useLocale must be used within LocaleProvider')
  }

  return context
}
